import reduxStore from './redux/ReduxStore';

 const env_var = new Proxy({}, {
     get: function(target, prop) {
         const state = reduxStore.getState();
         return state.config ? state.config[prop] : undefined;
     }
 });
 export {env_var}